import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SchemaJsonLdProps {
  schemas: object[];
}

export default function SchemaJsonLd({ schemas }: SchemaJsonLdProps) {
  const location = useLocation();

  useEffect(() => {
    const id = 'json-ld-schema';
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';

    const fullUrl = `https://pipicinema.com${location.pathname}`;
    const enriched = schemas.map((schema) => ({
      ...schema,
      url: (schema as Record<string, unknown>).url || fullUrl,
    }));

    script.textContent = JSON.stringify(enriched);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [schemas, location.pathname]);

  return null;
}